/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgTerrain = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="m18.723 9.698-6.158 6.213s-.036.035-.102.09L20.685 16v2l-17.383.002v-2H9.82l-.088-.086-.124-.122a7 7 0 0 1-.23-.231l-.706-.707-.354-.354-5.3-5.303L4.43 7.785l2.649 2.644 2.658 2.653c.037.021 1.413 1.414 1.413 1.414l6.073-6.298h-2.895v-2h6.393v6.5h-2z" /></svg>;
export default SvgTerrain;